import type { CalendarEventsResponse } from "@site-types/calendar"
import { type CSSProperties, useEffect } from "react"
import OptimizedImage from "../OptimizedImage"

const Events = (events: CalendarEventsResponse) => {
  useEffect(() => {
    const shipElement = document.querySelector(".ship")
    if (shipElement) {
      shipElement.classList.remove("place-center")
      shipElement.classList.add("place-back")
    }
  }, [])

  const aStyle: CSSProperties = {
    width: "100%",
    aspectRatio: "16 / 9",
    backgroundColor: "var(--green)",
  }
  const imgStyle: CSSProperties = {
    width: "100%",
    height: "100%",
    backgroundColor: "var(--pink)",
    display: "block",
    color: "var(--white)",
  }

  return (
    <div
      data-id="events-list"
      className="events"
    >
      {events.totalCount > 0 &&
        events.results.map((event, index) => (
          <div
            className="event"
            data-id={`event-${index}`}
            style={{ "--i": index } as CSSProperties}
            data-order={index}
            key={`event_${index}`}
          >
            <a
              href={event.taiyoroUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={aStyle}
            >
              <OptimizedImage
                draggable={false}
                src={event.imageUrl || event?.games?.[0]?.primaryImage}
                alt={event.name}
                width={640}
                height={360}
                style={imgStyle}
              />
            </a>
          </div>
        ))}
    </div>
  )
}

export default Events
